<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <h1 align="center">Login</h1>
        <login></login>
      </v-col>
      <v-col cols=12 md="6">
        <h1 align="center">Sign Up</h1>
        <register></register>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Login from "@/components/Login";
import Register from "@/components/Register";

export default {
  data: () => ({}),
  components: {
    "login": Login,
    "register": Register
  }
};
</script>
